import React, { useState } from "react";
import ILC_From from "./ilc_From/ILC_From";
import ILC_table from "./ilc_table/ILC_table";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function ILC({ validitydetails, setCurrentPage, currentPage ,openDeleteModal}) {
  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
                                            
  const haveReadPermission = permissions?.includes(FixIDS.ensuring_the_validity.List);
  const haveAddPermission = permissions?.includes(FixIDS.ilc.Add); //form

  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <ILC_From validityTypeId={6} onProceed={() => setShowTable(true)} />}
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        { haveReadPermission && <ILC_table
         openDeleteModal={openDeleteModal}
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          validityTypeId={6}
        />}
      </div>
      {/* )} */}
    </>
  );
}

export default ILC;
